"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("@mdi/react"));
const react_2 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const js_1 = require("@mdi/js");
function Dashboard({ routes, noTrans, logo, logoClass, categories, bg, prefix, shrinkable, }) {
    const [shrinked, setShrinked] = react_2.useState(false);
    const location = react_router_dom_1.useLocation();
    react_2.useEffect(() => {
        const removeAllActiveClasses = () => {
            const elements = document.querySelectorAll(".panel-active");
            elements.forEach((el) => {
                if (el.tagName === "DIV") {
                    el.classList.remove("has-background-primary");
                    const svg = el.childNodes[0];
                    svg.classList.remove("has-text-white");
                    svg.classList.add("has-text-neutral-dark80");
                }
                else {
                    el.classList.remove("has-text-primary");
                }
            });
        };
        const addAllActiveClasses = () => {
            var _a;
            const pathname = location.pathname
                .split("/")
                .filter((el) => el !== prefix)[1];
            const path = pathname === "settings" || pathname === "groups"
                ? "intranet"
                : pathname;
            if (pathname) {
                const el = document.querySelector(`.${path}`);
                const div = el === null || el === void 0 ? void 0 : el.childNodes[0];
                const p = el === null || el === void 0 ? void 0 : el.childNodes[1];
                div === null || div === void 0 ? void 0 : div.classList.add("has-background-primary");
                (_a = div === null || div === void 0 ? void 0 : div.childNodes[0]) === null || _a === void 0 ? void 0 : _a.classList.add("has-text-white");
                p === null || p === void 0 ? void 0 : p.classList.add("has-text-primary");
            }
        };
        removeAllActiveClasses();
        addAllActiveClasses();
    }, [location, prefix, shrinked]);
    return (react_2.default.createElement("div", { className: `column is-2-fullhd is-3-desktop is-4-tablet is-hidden-mobile p-0 height-100`, style: { width: shrinked ? "120px" : "" } },
        react_2.default.createElement("div", { className: `menu has-text-weight-semibold px-4 height-100 is-relative ${bg}` },
            react_2.default.createElement("div", { className: "py-5 px-3 mb-6" },
                react_2.default.createElement(react_router_dom_1.Link, { to: `/${prefix ? prefix : ""}` },
                    react_2.default.createElement("figure", { className: `${shrinked ? "image is-56x56" : ""}` },
                        react_2.default.createElement("img", { src: shrinkable && shrinked ? shrinkable.logo : logo, alt: "", className: logoClass })))),
            shrinkable && (react_2.default.createElement("div", { className: `menu-list-shrink ${shrinkable.className}`, onClick: () => setShrinked(!shrinked) },
                react_2.default.createElement(react_1.default, { path: js_1.mdiMenu, size: 1 }))),
            react_2.default.createElement("ul", { className: "menu-list is-relative" },
                categories &&
                    categories.map((category) => (react_2.default.createElement("div", { key: category.name },
                        !shrinked && (react_2.default.createElement("label", { className: "label is-size-4 ml-3 mb-4" }, category.name)),
                        category.routes.map((route) => (react_2.default.createElement(RouteComponent, { route: route, noTrans: noTrans, key: route.path || route.name, prefix: prefix, shrinked: shrinked })))))),
                routes &&
                    routes.map((route) => (react_2.default.createElement(RouteComponent, { route: route, noTrans: noTrans, key: route.path || route.name, prefix: prefix, shrinked: shrinked })))))));
}
exports.default = Dashboard;
function RouteComponent({ prefix, route, noTrans, shrinked }) {
    var _a;
    return (react_2.default.createElement("li", { key: route.name, className: `menu-list-el ${route.display ? "" : "is-hidden"}` },
        react_2.default.createElement(react_router_dom_1.Link, { to: `${route.path || route.name}`, className: `${shrinked ? "is-inline-flex" : "is-flex"} is-align-items-center ${((_a = route.path) === null || _a === void 0 ? void 0 : _a.replaceAll("/", "").replace(prefix || "", "")) ||
                route.name}` },
            react_2.default.createElement("div", { className: "has-background-primary p-4 is-flex is-align-items-center has-border-radius panel-active" },
                react_2.default.createElement(react_1.default, { size: 1, path: route.icon, className: "has-text-white" })),
            !shrinked && (react_2.default.createElement("p", { className: "panel-active ml-4" }, noTrans ? route.name : react_2.default.createElement(react_i18next_1.Trans, { i18nKey: route.name }))))));
}
//# sourceMappingURL=DashboardPanel.js.map